export const Constant = {
    GET:'GET',
    POST:'POST',
    PUT:'PUT',
    DELETE:'DELETE'
};
